import { Box, Button, Grid, Typography } from '@mui/material';
import FormsPopup from '../../common/FormsPopup/FormsPopup';
import { UpdateMemberAdditionalAddressProps } from './types';
import styles from './styles';
import InputField from '../../common/InputField/InputField';
import CustomSelect from '../../common/Select';
import USState from '../../../utils/USState';
import FormButton from '../../common/FormButton';

const UpdateMemberAdditionalAddress = ({
    updateMemberAdditionalAddress,
    handleCloseUpdateMemberAdditionalAddress,
    formErrors,
    handleInput,
    handleSubmit,
    memberAdditionalAddressInfo,
    memberFirstName,
    memberLastName,
    handleViewMoreAddress,
    showViewMoreAddresses,
    submitting,
}: UpdateMemberAdditionalAddressProps) => {
    return (
        <FormsPopup
            id="additional_member_address"
            open={updateMemberAdditionalAddress}
            title="Additional Addresses"
            textAlign="left"
            handleClose={handleCloseUpdateMemberAdditionalAddress}
            width={662}
        >
            <Box component="form" noValidate onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <InputField
                            id="firstname"
                            label="First Name"
                            name="firstname"
                            value={memberFirstName}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <InputField id="lastname" label="Last Name" name="lastname" value={memberLastName} disabled />
                    </Grid>
                </Grid>
                {memberAdditionalAddressInfo?.map((a, i) => (
                    <Box key={`Address ${i + 2}`}>
                        <Typography id={`address-heading-${i + 2}`} sx={styles.addressHeading}>
                            Address {i + 2}
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Typography sx={styles.addressField} component="div">
                                    <InputField
                                        required
                                        id="address1"
                                        label="Address"
                                        type="text"
                                        name="address1"
                                        placeholder="Type here..."
                                        onChange={(e) => handleInput(e, i)}
                                        value={a?.address1}
                                        error={formErrors?.[i]?.address1 !== undefined}
                                        errorMessage={formErrors?.[i]?.address1}
                                    />
                                </Typography>
                                <Typography sx={styles.addressField} component="div">
                                    <InputField
                                        required
                                        id="city"
                                        label="City"
                                        type="text"
                                        name="city"
                                        placeholder="Type here..."
                                        onChange={(e) => handleInput(e, i)}
                                        value={a?.city}
                                        error={formErrors?.[i]?.city !== undefined}
                                        errorMessage={formErrors?.[i]?.city}
                                    />
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography sx={styles.addressField} component="div">
                                    <InputField
                                        required
                                        id="address2"
                                        label="Apt Number"
                                        type="text"
                                        name="address2"
                                        placeholder="Type here..."
                                        onChange={(e) => handleInput(e, i)}
                                        value={a?.address2}
                                        error={formErrors?.[i]?.address2 !== undefined}
                                        errorMessage={formErrors?.[i]?.state}
                                    />
                                </Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <Typography sx={styles.addressField2} component="div">
                                            <CustomSelect
                                                name="state"
                                                label="State"
                                                id="state"
                                                handleOnchange={(e) => handleInput(e, i)}
                                                items={USState}
                                                value={a?.state}
                                                error={formErrors?.[i]?.state !== undefined}
                                                errorMessage={formErrors?.[i]?.state}
                                                customStyles={{ height: 44 }}
                                            />
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography sx={styles.addressField2} component="div">
                                            <InputField
                                                required
                                                id="zip"
                                                label="Zip Code"
                                                type="text"
                                                name="zip"
                                                placeholder="Type here..."
                                                onChange={(e) => handleInput(e, i)}
                                                value={a?.zip}
                                                error={formErrors?.[i]?.zip !== undefined}
                                                errorMessage={formErrors?.[i]?.zip}
                                            />
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                ))}
                <Grid container justifyContent="space-around" sx={styles.buttonsContainer}>
                    {showViewMoreAddresses && (
                        <Button id="viewMoreAddress" data-testid="viewMoreAddress" onClick={handleViewMoreAddress}>
                            View More
                        </Button>
                    )}
                    <FormButton
                        variant="contained"
                        sx={styles.saveButton}
                        type="submit"
                        id="updateMemberAdditionalAddress"
                        data-testid="updateMemberAdditionalAddress"
                        submitting={submitting}
                    >
                        Save changes
                    </FormButton>
                </Grid>
            </Box>
        </FormsPopup>
    );
};
export default UpdateMemberAdditionalAddress;
